import Swiper from "swiper/bundle";
import "swiper/css";

export function siblingNavSwiper() {
    document.querySelectorAll(".tabs-swiper .swiper-slide").forEach((slide, index) => {
        slide.addEventListener("click", () => {
            localStorage.setItem("selectedTabIndex", index);
        });
    });

    const tabsSwiper = new Swiper(".tabs-swiper", {
        slidesPerView: "auto",
        spaceBetween: 8,
        freeMode: true,
    });

    const savedIndex = localStorage.getItem("selectedTabIndex");
    if (savedIndex !== null) {
        setTimeout(() => {
            tabsSwiper.slideTo(parseInt(savedIndex), 0);
            localStorage.removeItem("selectedTabIndex");
        }, 100);
    }
}
